import { isMobile } from "react-device-detect";
const Notification = (props) => {
 

  let {notification, setNotification} = props

  let html = [<p> </p>]

  if(!notification)
    return html

  let {type, titre, message} = notification
  
  //let id = where === "top" ? "notification" : "notification2";
	let classValue = "";

  if(type === "warning")
    classValue = "alert notification"
  else if(type === "success")
    classValue = "alert success"
  else if(type === "error")
    classValue = "alert error"

  if(titre || (message && message.length > 0)){

    if(isMobile){
      html.push(
        [<br/>,<br/>]
      )
    }
    
    html.push(
      <div className={classValue}>
        <span style={{cursor : "pointer"}} className="close" onClick={() => {setNotification(null)}}></span>
        <dl>
          <dt>{titre}</dt>
          <dd>{
            message.map((m) => {
              return <span><li>{m}</li></span>
            })
            }
          </dd>
        </dl>
      </div> 
    )
    
   }

   if(!message || (message && message.length === 0))
    html = []
    
    return (
      <section style={{ paddingTop : "0.5rem"}}>
        <div className="columns twelve" style = {{paddingLeft : isMobile ? '1.5em' : '', paddingRight : isMobile ? '1.5em' : ''}}>
            {html}
        </div>

        </section>
    );
};
export default Notification;